import React, { useEffect } from 'react'
import { CategoryManager } from '../components/admin'
import useCategoryStore from '../stores/categoryStore'
import useMobileLayout from '../hooks/useMobileLayout'
import MobileAdminPage from '../components/mobile/MobileAdminPage'

export default function AdminPage() {
  const isMobile = useMobileLayout()
  const loadCategories = useCategoryStore(state => state.loadCategories)

  useEffect(() => {
    loadCategories()
  }, [loadCategories])

  if (isMobile) {
    return <MobileAdminPage />
  }

  return <CategoryManager />
}
